import axios from 'axios';

export type StaffStatus = 'ACTIVE' | 'INACTIVE' | 'RESIGNED';

export interface Department {
  id: string;
  name: string;
  description?: string | null;
  staffCount?: number;
  isActive?: boolean;
}

export interface Designation {
  id: string;
  name: string;
  departmentId?: string | null;
  department?: Department | null;
  isActive?: boolean;
}

export interface Staff {
  id: string;
  employeeCode: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  gender: string;
  dob?: string | null;
  mobile: string;
  email?: string | null;
  photo?: string | null;
  joiningDate: string;
  relievingDate?: string | null;
  status: StaffStatus | string;
  branchId?: string | null;
  departmentId?: string | null;
  designationId?: string | null;
  department?: Department | null;
  designation?: Designation | null;
  branch?: { id: string; branchCode: string; branchName?: string | null } | null;
}

export interface StaffAttendanceRow {
  staffId: string;
  employeeCode: string;
  name: string;
  department?: string | null;
  designation?: string | null;
  present: number;
  absent: number;
  leave: number;
  total: number;
}

export const staffApi = {
  listStaff: async (params?: Record<string, string | undefined>) => {
    const response = await axios.get('/staff', { params });
    return response.data as Staff[];
  },

  getStaff: async (id: string) => {
    const response = await axios.get(`/staff/${id}`);
    return response.data as Staff & { documents?: any[]; attendances?: any[]; reportingManagers?: any[]; salaryStructures?: any[] };
  },

  listDepartments: async () => {
    const response = await axios.get('/staff/departments');
    return response.data as Department[];
  },

  listDesignations: async (departmentId?: string) => {
    const response = await axios.get('/staff/designations', {
      params: departmentId ? { departmentId } : undefined,
    });
    return response.data as Designation[];
  },

  listResigned: async () => {
    const response = await axios.get('/staff/resigned');
    return response.data as Staff[];
  },

  departmentReport: async () => {
    const response = await axios.get('/staff/reports/department-wise');
    return response.data;
  },

  joiningReport: async (params?: { from?: string; to?: string }) => {
    const response = await axios.get('/staff/reports/joining', { params });
    return response.data as Staff[];
  },

  resignedReport: async (params?: { from?: string; to?: string }) => {
    const response = await axios.get('/staff/reports/resigned', { params });
    return response.data as Staff[];
  },

  monthlyAttendance: async (month: string) => {
    const response = await axios.get('/staff/attendance/monthly', { params: { month } });
    return response.data as StaffAttendanceRow[];
  },

  markAttendance: async (payload: {
    staffId: string;
    date: string;
    status: string;
    remarks?: string;
    branchId?: string;
    academicSessionId?: string;
  }) => {
    const response = await axios.post('/staff/attendance/mark', payload);
    return response.data;
  },
};
